module.exports = __webpack_public_path__ + "static/media/cv.f0add59f.svg";